export const SWAP_PRODUCT_ANALYTICS = {
  SWAP_PRODUCT_BUTTON: {
    eventCategory: 'Swap Product',
    eventAction: 'Click Change Product',
    eventLabel: 'Start the Change Product Workflow',
    interactionId: '1',
    description:
      'It starts the workflow to change the product for a customer initiated prescription',
  },
  SWAP_COUNT_BUTTON: {
    eventCategory: 'Swap Count',
    eventAction: 'Click Change Count',
    eventLabel: 'Start the Change Count Workflow',
    interactionId: '2',
    description:
      'It starts the workflow to change the count for a customer initiated prescription',
  },
  SWAP_PATIENT_BUTTON: {
    eventCategory: 'Swap Patient',
    eventAction: 'Click Change Patient',
    eventLabel: 'Start the Change Patient Workflow',
    interactionId: '3',
    description:
      'It starts the workflow to change the patient for a customer initiated prescription',
  },
  SWAP_PRODUCT_SEARCH_SELECT_PRODUCT: {
    eventCategory: 'Swap Product',
    eventAction: 'Select Product',
    eventLabel: 'Search - Select Product',
    interactionId: '4',
    description: 'The DVM selects the product and moves to the Rx Form',
  },
  SWAP_PRODUCT_SEARCH_CANCEL: {
    eventCategory: 'Swap Product',
    eventAction: 'Click Product Search Cancel',
    eventLabel: 'Search Form - Cancel',
    interactionId: '5',
    description: 'DVM wants to exit the workflow',
  },
  SWAP_PRODUCT_SEARCH_CANCEL_GO_BACK: {
    eventCategory: 'Swap Product',
    eventAction: 'Click',
    eventLabel: 'Cancel Pop up - go back',
    interactionId: '6',
    description: 'DVM still wans to continue the work',
  },
  SWAP_PRODUCT_SEARCH_CANCEL_CLOSE: {
    eventCategory: 'Swap Product',
    eventAction: 'Click',
    eventLabel: 'Cancel Pop up - Cancel',
    interactionId: '7',
    description: 'DVM still wans to continue the work',
  },
  SWAP_PRODUCT_SEARCH_CANCEL_DISCARD: {
    eventCategory: 'Swap Product',
    eventAction: 'Click',
    eventLabel: 'Cancel Pop up - Discard updates',
    interactionId: '8',
    description:
      'This means the DVM no longer wants to complete the workflow and this will be the egress point',
  },
  SWAP_PRODUCT_RX_FORM_CANCEL: {
    eventCategory: 'Swap Product',
    eventAction: 'Click',
    eventLabel: 'Rx Form - Cancel',
    interactionId: '10',
    description: 'DVM wants to exit the workflow',
  },
  SWAP_PRODUCT_FINALIZE_CANCEL: {
    eventCategory: 'Swap Product',
    eventAction: 'Click',
    eventLabel: 'Finalize Prescription Form - Cancel',
    interactionId: '11',
    description: 'DVM wants to exit the workflow',
  },
  SWAP_PRODUCT_FINALIZE_CONFIRM: {
    eventCategory: 'Swap Product',
    eventAction: 'Click Confirm Product Change',
    eventLabel: 'Change Product Complete',
    interactionId: '12',
    description: 'DVM Sucessfully Complete Swap',
  },
  SWAP_COUNT_FINALIZE_CANCEL: {
    eventCategory: 'Swap Count',
    eventAction: 'Click Finalize Cancel',
    eventLabel: 'Finalize Prescription Form for Change Count - Cancel',
    interactionId: '15',
    description: 'DVM wants to exit the workflow',
  },
  SWAP_COUNT_FINALIZE_CONFIRM: {
    eventCategory: 'Swap Count',
    eventAction: 'Click Confirm Change Count',
    eventLabel: 'Change Count Complete',
    interactionId: '16',
    description: 'DVM Sucessfully Complete Swap',
  },
  SWAP_PATIENT_SEARCH_CANCEL: {
    eventCategory: 'Swap Patient',
    eventAction: 'Click Change Patient Cancel',
    eventLabel: 'Change Patient Form - Cancel',
    interactionId: '17',
    description:
      'DVM selects to Close the screen (x) and goes to Cancel Confirmation pop-up',
  },
  SWAP_PATIENT_SEARCH_SELECT_PATIENT: {
    eventCategory: 'Swap Patient',
    eventAction: 'Click Select Patient',
    eventLabel: 'Patient Selected',
    interactionId: '18',
    description:
      'DVM Selects "Select Patient" and moves to Apprivng prescription',
  },
  SWAP_PATIENT_FINALIZE_CANCEL: {
    eventCategory: 'Swap Patient',
    eventAction: 'Click Finalize Cancel',
    eventLabel: 'Finalize Prescription Form for Change Patient - Cancel',
    interactionId: '21',
    description: 'DVM wants to exit the workflow',
  },
  SWAP_PATIENT_FINALIZE_CONFIRM: {
    eventCategory: 'Swap Patient',
    eventAction: 'Click Confirm Patient Change',
    eventLabel: 'Change Patient Complete',
    interactionId: '22',
    description: 'DVM Sucessfully Change Patient Swap',
  },
} as const

export type SwapProductAnalyticsKey = keyof typeof SWAP_PRODUCT_ANALYTICS

export const getSwapProductTrackingData = (
  eventType: SwapProductAnalyticsKey,
  prescription: { businessId: string; id: string },
) => ({
  eventCategory: SWAP_PRODUCT_ANALYTICS[eventType].eventCategory,
  eventAction: SWAP_PRODUCT_ANALYTICS[eventType].eventAction,
  eventLabel: SWAP_PRODUCT_ANALYTICS[eventType].eventLabel,
  interactionId: SWAP_PRODUCT_ANALYTICS[eventType].interactionId,
  description: SWAP_PRODUCT_ANALYTICS[eventType].description,
  prescriptionId: prescription.id,
  businessId: prescription.businessId,
})
